import React, { Component } from "react";
import { connect } from "react-redux";

import LocaleStrings from "@language";
import { RadioGroup } from "@headlessui/react";
import UsdIocn from "@UsdIocn";
import QarIocn from "@QarIocn";
// Import BaseLoader
import BaseLoader from "@baseLoader";
// Functions Import
import { classNames } from "@commonFunction";
// Import Action
import { setCurrency } from "@mainActions";
import toast from "react-hot-toast";
const settings = [
  { name: "QAR", description: LocaleStrings.qatari_riyal, src: QarIocn },
  { name: "USD", description: LocaleStrings.dollar, src: UsdIocn },
];

class Currency extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      loaderDesc: LocaleStrings.preparing_currency,
      selected: settings[0],
    };

    // All Binded Functions
  }

  //Arrow function for renderLoader
  renderLoader = () => {
    return <BaseLoader data={this.state.loaderDesc} />;
  };

  // On Radio Chnage
  onRadioChange = (e) => {
    let { session } = this.props;

    // Update database for this user
    this.props.setCurrency(session, e.name, (callback) => {
      if (callback.success === 1) {
        this.setState({ selected: e }); // Chnage the state too
      } else {
        toast.error(callback.message);
      }
    });
  };

  componentDidMount() {
    if (this.props.currency === "USD") {
      this.setState({ selected: settings[1] });
    }
    this.setState({ loading: false });
  }

  componentWillUnmount() {
    this.setState({ loading: true });
  }

  render() {
    return (
      <>
        {this.props.user.isfreeze == false ? (
          <>
            {this.state.loading ? (
              <>{this.renderLoader()}</>
            ) : (
              <div className="py-6 responsivePadding">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  <h1 className="text-2xl font-semibold text-secondary">
                    {LocaleStrings.change_currency}
                  </h1>
                </div>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  {/* Replace with your content */}
                  <div className="py-4">
                    <RadioGroup
                      value={this.state.selected}
                      onChange={(e) => this.onRadioChange(e)}>
                      <RadioGroup.Label className="sr-only">
                        Privacy setting
                      </RadioGroup.Label>
                      <div className="bg-custWhite rounded-md -space-y-px">
                        {settings.map((setting, settingIdx) => (
                          <RadioGroup.Option
                            key={setting.name}
                            value={setting}
                            className={({ checked }) =>
                              classNames(
                                settingIdx === 0
                                  ? "rounded-tl-md rounded-tr-md"
                                  : "",
                                settingIdx === settings.length - 1
                                  ? "rounded-bl-md rounded-br-md"
                                  : "",
                                checked
                                  ? "bg-primaryLight border-primaryHover z-10"
                                  : "border-quaternary",
                                "relative border p-4 flex cursor-pointer focus:outline-none"
                              )
                            }>
                            {({ active, checked }) => (
                              <>
                                <span
                                  className={classNames(
                                    checked
                                      ? "bg-primary border-transparent"
                                      : "bg-custWhite border-quaternary",
                                    active
                                      ? "ring-2 ring-offset-2 ring-primaty"
                                      : "",
                                    "h-4 w-4 mt-0.5 cursor-pointer rounded-full border flex items-center justify-center"
                                  )}
                                  aria-hidden="true">
                                  <span className="rounded-full bg-custWhite w-1.5 h-1.5" />
                                </span>
                                <div className="mx-3 flex flex-col">
                                  <RadioGroup.Label
                                    as="span"
                                    className={classNames(
                                      checked
                                        ? "text-primary"
                                        : "text-secondary",
                                      "block text-sm font-medium"
                                    )}>
                                    {setting.name}
                                  </RadioGroup.Label>
                                  <RadioGroup.Description
                                    as="span"
                                    className={classNames(
                                      checked ? "text-primary" : "text-ternary",
                                      "block text-sm"
                                    )}>
                                    {setting.name === "QAR"
                                      ? LocaleStrings.qatari_riyal
                                      : LocaleStrings.dollar}
                                  </RadioGroup.Description>
                                </div>
                              </>
                            )}
                          </RadioGroup.Option>
                        ))}
                      </div>
                    </RadioGroup>
                  </div>
                  {/* /End replace */}
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="flex items-center justify-center h-screen">
            <div className="text-center">{LocaleStrings.account_freezed}</div>
          </div>
        )}
      </>
    );
  }
}

var mapStateToProps = (state) => ({
  isLoggedIn: state.isLoggedIn,
  user: state.user,
  session: state.session,
  localCurrency: state.localCurrency,
  currency: state.currency,
});

export default connect(mapStateToProps, { setCurrency })(Currency);
